<div class="grid-container padding-bottom-4">
  <form [formGroup]="shipmentReviewForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          <legend class="usa-legend usa-legend--large">Shipment Review</legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 ">
          @if (!carrierUser) {
            <label for="status">Status<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
          }
          <div>
            <div class="grid-row grid-gap-2">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                @if (!carrierUser) {
                  <select formControlName="status" id="status" name="status" placeholder="Status" class="usa-select margin-top-0">
                    <option value=''>All</option>
                    @for (status of statuses; track status) {
                      <option [ngValue]="status">{{status}}</option>
                    }
                  </select>
                }
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <button type="button" class="usa-button" (click)="refreshTableandStatus()">Refresh</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (isFormElementInValid('status')) {
        <div class="grid-row">
          <div class="usa-alert usa-alert--error usa-alert--slim">
            <div class="usa-alert__body">
              <p class="usa-alert__text">
                Status is required
              </p>
            </div>
          </div>
        </div>
      }
    </fieldset>
  </form>
  <div class="grid-row grid-gap margin-top-5">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine" [gridOptions]="shipmentReviewGridOptions" [rowData]="shipmentReviewListBeforeEditFields" [suppressDragLeaveHidesColumns]="true">
      </ag-grid-angular>
    </div>
  </div>
</div>